import React, { useState, useRef, useEffect } from "react";
import Overlay from "react-bootstrap/Overlay";
import Popover from "react-bootstrap/Popover";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Sidebar.css";
import { Link } from "react-router-dom";

function Sidebar() {
  const [target, setTarget] = useState();
  const [showSos, setShowSos] = useState(false);
  const [location, setLocation] = useState(null);
  let images = [];
  let video = null;

  useEffect(() => {
    const elements = document.getElementsByClassName("arrow");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("popover-arrow");
    }

    if (showSos && !location && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (loc) => {
          setLocation({
            latitude: loc.coords.latitude,
            longitude: loc.coords.longitude,
          });
          console.log(loc);
        },
        (e) => {
          console.log(e);
        }
      );
    }
  }, [showSos]);

  const submitForm = (e) => {
    e.preventDefault();
    // display loading...........
    const data = new FormData();
    data.append(
      "location",
      location ? `${location.latitude},${location.longitude}` : null
    );
    data.append("name", e.target.name.value);
    data.append("phone", e.target.contact.value);
    data.append("message", e.target.message.value);
    data.append("images", images);
    data.append("video", video);
    axios
      .post("https://animal-ngo.herokuapp.com/application/sos", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => alert(res.data)) // request complete with res 200
      .catch((err) => alert("Something went wrong.")); // request complete with res 4xx
  };

  // Check image size and allow max 3 images only
  const onImageUpload = (e) => {
    if (e.target.files) {
      if (e.target.files.length > 3) {
        alert("Max 3 images of size less then 500KB allowed");
      }
      let selected = 0;
      for (let i = 0; i < e.target.files.length; i++) {
        const file = e.target.files[i];
        if (selected >= 3) {
          break;
        } else if (file.size <= 512000) {
          // 500KB = 5,12,000Bytes
          selected++;
          images.push(file);
        }
      }
    } else {
      images = [];
    }
  };

  // check video size before uploading
  const onVideoUpload = (e) => {
    if (e.target.files) {
      // 5MB = 52,42,880Bytes
      if (e.target.files[0].size <= 5242880) {
        video = e.target.files[0];
      } else {
        alert("Vide size must be less then 5MB");
      }
    } else {
      video = null;
    }
  };

  return (
    <div className="right-sidebar" id="right-sidebar">
      <div className="right-sidebar-menu">
        <a
          href="#engage"
          onClick={() => {
            document
              .getElementById("v-pills-csr-tab")
              .classList.remove("active");
            document
              .getElementById("v-pills-donate-tab")
              .classList.add("active");
            document.getElementById("v-pills-donate-tab").click();
          }}
          className="text-normal"
        >
          Give
        </a>
      </div>
      <div
        ref={setTarget}
        onClick={() => setShowSos((prev) => !prev)}
        className="right-sidebar-menu"
      >
        SOS
      </div>
      <Overlay
        placement="left"
        show={showSos}
        target={target}
        container={this}
        offset={[100, 100]}
      >
        <Popover offset={[100, 100]} className="bs-popover-start sos">
          <Popover.Content>
            <h5>SOS - organize emergency rescue</h5>
            <CloseIcon
              className="close-icon"
              onClick={() => setShowSos(false)}
            />
            <form method="post" onSubmit={submitForm}>
              <div className="sender-detail">
                <input type="text" name="name" placeholder="Name" required />
                <input type="tel" name="contact" placeholder="Phone" required />
              </div>
              <div className="data">
                <label htmlFor="image">Upload Image</label>
                <label htmlFor="video">Upload Video</label>
                <input
                  type="file"
                  name="image"
                  accept="image/*"
                  multiple
                  onChange={onImageUpload}
                />
                <input
                  type="file"
                  name="video"
                  accept="video/*"
                  onChange={onVideoUpload}
                />
              </div>
              <textarea
                name="message"
                maxLength="500"
                placeholder="message"
              ></textarea>
              <div className="submit-btn">
                <input type="submit" value="submit" />
              </div>
            </form>
          </Popover.Content>
        </Popover>
      </Overlay>
      <div className="right-sidebar-menu">
        <Link to="/shop" className="text-normal">
          Shop
        </Link>
      </div>
    </div>
  );
}

export default Sidebar;
